<template>
  <v-dialog
    v-model="dialog"
    width="600"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <v-card>
      <v-card-title class="amber darken-1 white--text">
        <span class="text-uppercase">Thêm phòng học</span>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <room-info-form ref="form" />
      <v-card-actions class="pr-6 pb-6 mt-n8">
        <v-spacer></v-spacer>
        <v-btn depressed class="px-4" color="primary" @click="save" :loading="loading"
          ><v-icon>mdi-plus</v-icon>Lưu</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import RoomInfoForm from '@/components/basic/form/RoomForm.vue'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    RoomInfoForm
  },
  props: {
    state: Boolean,
    major: Object,
    course: Object
  },
  data() {
    return {
      dialog: false,
      loading: false
    }
  },
  computed: {
    ...mapState('app', ['roles', 'department']),
    ...mapState('auth', ['user'])
  },
  methods: {
    ...mapActions('rooms', ['createRoom']),
    async save() {
      this.loading = true
      let data = this.$refs.form.getData()
      await this.createRoom({ ...data })
      this.loading = false
      this.$refs.form.reset()
      this.dialog = false
      this.$alert.success('Thêm mới buổi học thành công!')
    },
    cancel() {
      this.$refs.form.reset()
      this.dialog = false
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
